import React from "react";
import HomeLayout from "../layouts/home";
import { useTranslation } from "../contexts/I18nProvider";

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <HomeLayout>
      <div className="max-w-4xl mx-auto p-6 text-gray-800">
        <h1 className="text-3xl font-bold mb-4">{t('pages.privacy.title')}</h1>
        <p className="mb-4">
          {t('pages.privacy.intro')}
        </p>

        {/* Section 1: Information Collection */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">
            {t('pages.privacy.infoCollection')}
          </h2>
          <p>{t('pages.privacy.infoCollectionDesc')}</p>
          <ul className="list-disc list-inside mt-2">
            <li>
              {t('pages.privacy.personalInfo')}
            </li>
            <li>
              {t('pages.privacy.usageData')}
            </li>
            <li>
              {t('pages.privacy.deviceInfo')}
            </li>
          </ul>
        </section>

        {/* Section 2: Use of Information */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">
            {t('pages.privacy.infoUse')}
          </h2>
          <p>{t('pages.privacy.infoUseDesc')}</p>
          <ul className="list-disc list-inside mt-2">
            <li>{t('pages.privacy.provideServices')}</li>
            <li>{t('pages.privacy.processPayments')}</li>
            <li>
              {t('pages.privacy.sendNotifications')}
            </li>
            <li>{t('pages.privacy.analyzeUsage')}</li>
          </ul>
        </section>

        {/* Section 3: Data Sharing */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">{t('pages.privacy.dataSharing')}</h2>
          <p>
            {t('pages.privacy.dataSharingDesc')}
          </p>
          <ul className="list-disc list-inside mt-2">
            <li>
              {t('pages.privacy.paymentProcessors')}
            </li>
            <li>
              {t('pages.privacy.legal')}
            </li>
            <li>
              {t('pages.privacy.businessTransfer')}
            </li>
          </ul>
        </section>

        {/* Section 4: Data Security */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">{t('pages.privacy.dataSecurity')}</h2>
          <p>
            {t('pages.privacy.dataSecurityDesc')}
          </p>
        </section>

        {/* Section 5: User Rights */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">{t('pages.privacy.userRights')}</h2>
          <p>{t('pages.privacy.userRightsDesc')}</p>
          <ul className="list-disc list-inside mt-2">
            <li>{t('pages.privacy.accessData')}</li>
            <li>{t('pages.privacy.correctData')}</li>
            <li>{t('pages.privacy.withdrawConsent')}</li>
            <li>
              {t('pages.privacy.contactPrivacy')}{" "}
              <a
                href={`mailto:${process.env.REACT_APP_PRIVACY_EMAIL}`}
                className="text-blue-500 underline"
              >
                {process.env.REACT_APP_PRIVACY_EMAIL}
              </a>
              .
            </li>
          </ul>
        </section>

        <footer className="text-sm text-gray-800 mt-8">
          <p>
            {t('pages.privacy.contactPrivacy')}{" "}
            <a
              href={`mailto:${process.env.REACT_APP_PRIVACY_EMAIL}`}
              className="text-blue-500 underline"
            >
              {process.env.REACT_APP_PRIVACY_EMAIL}
            </a>
            .
          </p>
          <p className="mt-2">
            {t('pages.terms.effectiveDate')}: {new Date().toLocaleDateString()}
          </p>
        </footer>
      </div>
    </HomeLayout>
  );
};

export default Privacy;
